<ion-header class="order-header" color="primary">
    <ion-toolbar >
        <ion-buttons slot="start">
            <custom-back-button (backButtonClick)="backButtonClick()"></custom-back-button>

        </ion-buttons>
        <ion-buttons slot="primary">
            <div  *ngIf="settings.enableSearch">
                <ion-button fill="clear" (click)="tapSearch()" class="search-btn">
                    <ion-icon name="md-search" class="h-nav-cart"></ion-icon>
                </ion-button>
            </div>
            <div class="h-nav">
                <ion-button fill="clear" (click)="cartClicked()">
                    <ion-icon name="md-cart" class="h-nav-cart">
                    </ion-icon>
                    <ion-badge *ngIf="!multOrderManager.enableMutlOrder" id="notifications-badge" color="danger">
                        {{orderManager.count}}</ion-badge>
                    <ion-badge *ngIf="multOrderManager.enableMutlOrder" id="notifications-badge" color="danger">
                        {{multOrderManager.getOrderCount()}}</ion-badge>
                </ion-button>
            </div>
        </ion-buttons>
    </ion-toolbar>
    <ion-toolbar *ngIf="categories" transparent no-padding>
        <div class="cat-tab-wrapper">
            <ion-button (click)="catClicked(fab, cat)" *ngFor="let cat of categories;let i = index"
                        [ngClass]="{'no-img-button': !catImages[i]}"
                        class="cat-tab AQA-Category" id="{{ cat.id === category.id ? 'active' : '' }}"
                        fill="clear">
                <div *ngIf="catImages[i]" class="img-box">
                    <img (error)="showEmpty(i)" src="{{catImages[i]}}"/>
                </div>
                <span>{{cat.name}}</span>
            </ion-button>
        </div>
    </ion-toolbar>
</ion-header>

<ion-content fullscreen="true" class="item-grid-content"
    [ngClass]="{'dim-bg': isfabOpen , 'scrollLock' : isVariationOpened}">

   <!-- <div *ngIf="bannerImg" class="category-banner" [ngStyle]="{'background-image': 'url(' + bannerImg + ')'}">
        <div class="dim-bg"></div>
        <div class="cate-info">
            <p class="name">{{category.name}}</p>
            &lt;!&ndash; Desc Here &ndash;&gt;
            <p class="desc line-clamp"></p>
        </div>
    </div>-->

    <!-- gridlayout -->
    <!-- <div class="original-layout" *ngIf="!isInfiniteScroll">
        <div class="item-grid-wrapper grid2">

            <div *ngFor="let item of items;let i = index" class="div-col">
                <app-grid-layout-item (addClick)="addClicked(item)" (removeClick)="removeClicked(item)" [index]="i"
                    [item]="item" [category]="category" [imgs]="imgs" [tagsImage]="tagsImage"
                    [quantity]="orderManager.getQuantity(item)" [currencySign]="orderManager?.store?.currencySign">
                </app-grid-layout-item>
            </div> -->



    <!-- gridlayout -->

    <ng-container *ngIf="!isInfiniteScroll; else elseTemplate">
        <div class="original-layout">

            <!-- grid2 -->
            <div *ngIf="groups && mode == 'grid'" class="item-grid-wrapper grid2">
                <div *ngFor="let item of items;let i = index" class="div-col">
                    <app-grid-layout-item (addClick)="addClicked(item)" (removeClick)="removeClicked(item)" [index]="i"
                        [item]="item" [category]="category" [imgs]="imgs" [tagsImage]="tagsImage"
                        [quantity]="orderManager.getQuantity(item)" [currencySign]="orderManager?.store?.currencySign" [orderManager]="orderManager">
                    </app-grid-layout-item>
                </div>
            </div>

            <!-- grid3 -->
            <ion-grid *ngIf="groups && mode == 'grid3'" class="item-grid-wrapper grid3">
                <ion-row>
                    <ion-col *ngFor="let item of items;let i = index" size="4">
                        <ion-card (click)="addClicked(item)"
                            [ngClass]="{'AQA-setItem': isSet(item), 'AQA-aLaCarteItem': !isSet(item)}"
                            class="item-wrapper animated fadeInUps grid3" ng-switch-when="category">
        
                            <div class="img-square center-cropped" style="background: white;">
        
                                <div *ngIf="item.tags.length > 0" class="tag-image-box grid3">
                                    <div class="tag-images-wrapper">
                                        <ng-container *ngFor="let tagsImg of item.tags">
                                            <img *ngIf="tagsImage[tagsImg]" src="{{tagsImage[tagsImg]}}"
                                                [ngClass]="{'single' : item.tags.length == 1}">
        
                                        </ng-container>
                                    </div>
                                </div>
                                <!-- <div *ngIf="item.tags.length > 0" [ngStyle]="{'background-image': 'url(' + getTagsImage(item) + ')'}"></div> -->
                                <div class="item-img-box">
                                    <img src="{{imgs[i]}}" (error)="showEmpty(i)" />
                                </div>
        
                                <div class="sold-out-box AQA-soldOut" *ngIf="isSoldout(item)">
                                    <span>{{"pages.item-grid.soldout" | translate}}</span>
                                </div>
        
                                <div class="qty-panel" *ngIf="orderManager.getQuantity(item) > 0 && !isSet(item)">
                                    <ion-button fill="clear" class="btn-qty-remove AQA-minus-button" size="small"
                                        (click)="removeClicked(item);$event.stopPropagation();">
                                        <ion-icon name="md-remove"></ion-icon>
                                    </ion-button>
        
                                    <div class="qtn-with-item">
                                        
                                        <h5 class="AQA-item-qty">{{orderManager.getQuantity(item)}}</h5>
        
                                    </div>
                                    <ion-button fill="clear" size="small" class="btn-qty-add AQA-add-button">
                                        <ion-icon name="md-add"></ion-icon>
                                    </ion-button>
        
                                </div>
        
                            </div>
                            <div class="item-info" [ngClass]="{ isEn : translateService?.currentLang === 'en'}">
                                <div class="item-title">
                                    {{getItemName(item)}}
                                </div>
                                <div class="item-price" *ngIf="!settings.hideZeroItemPrice || item.price > 0">
                                    <span *ngIf="!item.minPrice" class="itemPrice-text">
                                        {{orderManager?.store?.currencySign}}
                                        {{item | itemPrice}}
                                    </span>
                                    <span *ngIf="item.minPrice" class="itemPrice-text">
                                        {{orderManager?.store?.currencySign}}
                                        {{ item.minPrice | number : '1.0-2'}}
                                        {{"global.up" | translate}}
                                    </span>
                                    <!-- <span>{{orderManager?.store?.currencySign}}{{item.price | number : '1.0-2'}}</span> -->
                                    <!-- <ion-icon *ngIf="isSet(item)" class="icon-next" name="ios-arrow-forward"></ion-icon> -->
                                </div>
                            </div>
                        </ion-card>
                    </ion-col>
        
                </ion-row>
            </ion-grid>

            <!-- list -->
            <ion-list *ngIf="groups && mode == 'list'" class="listMode">
                <ion-item *ngFor="let item of items;let i = index" class="item-list-box animated fadeInUps"
                    (click)="addClicked(item)" [ngClass]="{'AQA-setItem': isSet(item), 'AQA-aLaCarteItem': !isSet(item)}">
        
                    <div *ngIf="isSoldout(item)" class="sold-out-box AQA-soldOut">
                        <p>{{"pages.item-grid.soldout" | translate}}</p>
                    </div>
        
                    <ion-thumbnail slot="end" *ngIf="getImage(item)">
                        <img src="{{getImage(item)}}">
                    </ion-thumbnail>
        
                    <!-- Action bar for Set -->
                    <div class="pre-quantity-box" *ngIf=" isSet(item) && orderManager.getQuantity(item) === 0" slot="end">
                        <ion-icon color="dark" name="arrow-forward"></ion-icon>
                    </div>
                    <!-- Action bar for A-la-carte -->
                    <div class="pre-quantity-box"
                        *ngIf=" !isSet(item) && (isRequiredModifier(item) ||(!store.menu.quickSingleItem && isModifiable(item))) "
                        slot="end">
                        <ion-icon color="dark" name="arrow-forward"></ion-icon>
                    </div>
        
        
                    <div class="pre-quantity-box"
                        *ngIf=" !isSet(item) && !isRequiredModifier(item) && (store.menu.quickSingleItem || !isModifiable(item)) && orderManager.getQuantity(item) === 0"
                        slot="end">
                        <ion-button fill="clear" class="aig-add-circle AQA-add-button">
                            <ion-icon name="add-circle-outline" color="success"></ion-icon>
                        </ion-button>
                    </div>
                    <div class="quantity-box"
                        *ngIf=" !isSet(item) && !isRequiredModifier(item) && (store.menu.quickSingleItem || !isModifiable(item)) && orderManager.getQuantity(item) > 0"
                        slot="end">
                        <ion-button fill="clear" class="aig-add-circle AQA-add-button">
                            <ion-icon name="add-circle-outline" color="success"></ion-icon>
                        </ion-button>
                        <ion-button fill="clear" (click)="removeClicked(item);$event.stopPropagation();"
                            class="aig-minus-circle AQA-minus-button">
                            <ion-icon name="remove-circle-outline" color="medium"></ion-icon>
                        </ion-button>
                    </div>
                    <div>
                        <div class="name-box">
                            <p class="name-text line-clamp">
                                <ng-container *ngIf="orderManager.getQuantity(item) > 0">
                                    <span class="qty-text">{{orderManager.getQuantity(item)}}x </span>
                                </ng-container>
                                {{getItemName(item)}}
                            </p>
                            <div *ngIf="item.tags.length > 0" class="tag-image-box list">
                                <ng-container *ngFor="let tagsImg of item.tags">
                                    <img *ngIf="tagsImage[tagsImg]" src="{{tagsImage[tagsImg]}}"
                                        [ngClass]="{'single' : item.tags.length == 1}">
                                </ng-container>
                            </div>
                        </div>
        
                        <p class="desc-text line-clamp-3" *ngIf="item.desc AQA-itemDesc">{{ item.desc }}</p>
        
                        <div *ngIf="item.prefix.length > 0" class="tag-image-box prefix-box grid3">
                            <p *ngIf="item.price > 0 || !settings.hideZeroItemPrice" class="price-text itemPrice-text">
                                {{orderManager?.store?.currencySign}}
                                {{item | itemPrice}}
                            
                            </p>
                            <div class="tag-images-wrapper prefix-wrapper">
                                <span>{{item.prefix}}</span>
                            </div>
                        </div>
        
                        <ng-container *ngIf="!(item.prefix && item.prefix.length > 0)">
        
                            <p *ngIf="item.price > 0 || !settings.hideZeroItemPrice" class="price-text itemPrice-text">
                                <span *ngIf="!item.minPrice"
                                    class="itemPrice-text">{{orderManager?.store?.currencySign}}
                                    {{item | itemPrice}}</span>
                                <span *ngIf="item.minPrice"
                                    class="itemPrice-text">{{orderManager?.store?.currencySign}}{{ item.minPrice | number : '1.0-2'}}
                                    {{"global.up" | translate}}</span>
                            </p>
        
                        </ng-container>
        
                        <!-- <p class="price-text" *ngIf="!settings.hideZeroItemPrice || item.price > 0">{{orderManager?.store?.currencySign}}{{ item.price | number : '1.0-2'}}</p> -->
                    </div>
        
                </ion-item>
        
            </ion-list>


        </div>
    </ng-container>

    <!-- infiniteScroll layout -->
    <ng-template #elseTemplate>
        <div>
            <!-- hide the sticky because the adaptation problem-->
            <!-- <div class="header-sticky-cat-title">
                <p>{{category.name}}</p>
            </div> -->
            <virtual-scroller (vsChange)="change($event)" #scroll [items]="allAvailableItems" bufferAmount="20"
                class="scrollView" [enableUnequalChildrenSizes]="true">
                <!-- <div class="sticky-cat-title">
                    <p *ngIf="item[0]?.catName">{{item[0]?.catName}}</p>
                </div> -->
                <div *ngFor="let item of scroll.viewPortItems;let i = index" class="double-items-row"
                    [ngClass]="{'list-mode-flex-box': getComponentMode(item[0])=='list'}">
                    <div class="cat-title">
                        <p *ngIf="item[0]?.catName">{{item[0]?.catName}}</p>
                    </div>
                    <app-grid-layout-item-double (addClick)="addClicked($event.item, $event.callBack)"
                                                 (removeClick)="removeClicked($event.item, $event.callBack)"
                                                 [category]="findCategory(item[0])"
                                                 [tagsImage]="tagsImage" [items]="item"
                                                 [currencySign]="orderManager?.store?.currencySign"
                                                 [defaultImage]="defaultImage" [orderManager]="orderManager">
                    </app-grid-layout-item-double>
                </div>
            </virtual-scroller>
        </div>
    </ng-template>
</ion-content>


<ion-footer [ngClass]="{'hasItem': orderManager.count > 0}" class="abs-footer">
    <ion-button expand="block" (click)="cartClicked()"
        class="AQA-key-button key-btn-box order-btn full-btn-shadow AQA-checkout-button flashit">
        <ion-chip [ngClass]="{'animated popped' : isBounce}" class="item-count-chip">
            <ion-label>{{orderManager.count}}</ion-label>
        </ion-chip>
        <p class="checkout-text">
            {{"global.checkout" | translate}}
            <ng-container *ngIf="settings && !settings.hidePrice">
                {{orderManager?.store?.currencySign}}{{orderManager?.order?.grandTotal | number : '1.0-2'}}
            </ng-container>
        </p>
        <ion-icon slot="end" name="ios-arrow-forward"></ion-icon>
    </ion-button>
</ion-footer>
